// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_VideoImg__ZwTmT .VideoDetails_VideoBtn__CakRH {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
}

.VideoDetails_scroll__cJR2D::-webkit-scrollbar {
  height: 8px;
}
.VideoDetails_scroll__cJR2D::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.VideoDetails_scroll__cJR2D::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.VideoDetails_VideoDetails__IVkEA {
  padding: 20px 20px 0 20px;
  background-color: var(--bgColor);
  border: 1px solid var(--borderColor);
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_Tabs__HHpPB {
  font-size: 14px !important;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  margin-bottom: 20px;
}
body[dir=ltr] .VideoDetails_VideoDetails__IVkEA .VideoDetails_Tabs__HHpPB {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .VideoDetails_VideoDetails__IVkEA .VideoDetails_Tabs__HHpPB {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_Tabs__ArTab__Mc76h {
  -webkit-border-end: 1px solid var(--borderColor);
          border-inline-end: 1px solid var(--borderColor);
  -webkit-margin-end: 20px;
          margin-inline-end: 20px;
  -webkit-padding-end: 20px;
          padding-inline-end: 20px;
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_active__ribWV {
  color: var(--secondaryColor);
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_heading__OfVcZ {
  text-transform: capitalize;
  font-size: 10px !important;
}
.VideoDetails_VideoDetails_Title__8rDvt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.VideoDetails_VideoDetails_Title__8rDvt h3 {
  font-size: 14px !important;
}
body[dir=ltr] .VideoDetails_VideoDetails_Title__8rDvt h3 {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .VideoDetails_VideoDetails_Title__8rDvt h3 {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
.VideoDetails_VideoDetails_Content__-UNo9 {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 20px;
}
@media (max-width: 992px) {
  .VideoDetails_VideoDetails_Content__-UNo9 {
    flex-direction: column;
  }
}
.VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_VideoImg__ZwTmT {
  width: 332px;
  height: 223px;
  overflow: hidden;
  -webkit-margin-end: 20px;
          margin-inline-end: 20px;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
}
@media (max-width: 992px) {
  .VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_VideoImg__ZwTmT {
    -webkit-margin-end: 0;
            margin-inline-end: 0;
    margin-bottom: 20px;
    width: 100%;
  }
}
.VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_VideoImg__ZwTmT img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_VideoImg__ZwTmT .VideoDetails_VideoBtn__CakRH {
  background-color: var(--bgColor);
  width: 61px;
  height: 61px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--secondaryColor);
}
.VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_VideoPost__V4jSB h5 {
  font-size: 14px !important;
  margin-bottom: 5px;
}
body[dir=ltr] .VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_VideoPost__V4jSB h5 {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_VideoPost__V4jSB h5 {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
.VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_VideoPost__V4jSB .VideoDetails_showLessDetails__cw\\+ev {
  max-height: 150px;
}
.VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_VideoPost__V4jSB .VideoDetails_videoPost_Text__lyXC7 {
  font-size: 12px !important;
  line-height: 22px;
  width: 100%;
  white-space: pre-line;
  overflow: hidden;
  margin-bottom: 20px;
  font-family: inherit;
  word-break: break-word;
}
.VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_VideoPost__V4jSB .VideoDetails_showMoreDetailsToggle__aXEou {
  cursor: pointer;
}
.VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_SpeechToText__GQ5g\\+ {
  margin-bottom: 30px;
}
.VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_SpeechToText__GQ5g\\+ h5 {
  font-size: 14px !important;
  margin-bottom: 5px;
}
body[dir=ltr] .VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_SpeechToText__GQ5g\\+ h5 {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_SpeechToText__GQ5g\\+ h5 {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
.VideoDetails_VideoDetails_Content__-UNo9 .VideoDetails_SpeechToText__GQ5g\\+ span {
  font-size: 12px;
}
.VideoDetails_VideoDetails__IVkEA .MuiAccordion-root {
  margin-top: 0;
  border: 0;
  display: flex;
  flex-direction: column;
}
.VideoDetails_VideoDetails__IVkEA .MuiAccordionSummary-root {
  padding: 12px;
  min-height: 0;
  min-height: initial;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--borderColor);
  order: 1;
}
.VideoDetails_VideoDetails__IVkEA .MuiAccordionSummary-root.Mui-expanded {
  min-height: 0;
  min-height: initial;
}
.VideoDetails_VideoDetails__IVkEA .MuiAccordionSummary-content {
  margin: 0;
  flex-grow: initial;
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
  color: var(--mainColor);
  font-size: 10px !important;
}
.VideoDetails_VideoDetails__IVkEA .MuiAccordionSummary-content.Mui-expanded {
  margin: 0;
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.VideoDetails_VideoDetails__IVkEA .MuiAccordionDetails-root {
  padding: 0 0 20px 0;
  flex-direction: column;
}
.VideoDetails_VideoDetails__IVkEA .MuiIconButton-edgeEnd {
  margin-right: 0;
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q:not(:last-child) {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--borderColor);
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q .VideoDetails_Img__A\\+kyh {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  -webkit-margin-end: 15px;
          margin-inline-end: 15px;
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q .VideoDetails_Img__A\\+kyh svg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q .VideoDetails_Details__4Ej1c h5 {
  font-size: 14px !important;
  margin-bottom: 5px;
  text-transform: capitalize;
}
body[dir=ltr] .VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q .VideoDetails_Details__4Ej1c h5 {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q .VideoDetails_Details__4Ej1c h5 {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q .VideoDetails_Details__4Ej1c p {
  font-size: 12px !important;
  margin-bottom: 10px;
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q .VideoDetails_Details__4Ej1c .VideoDetails_Actions__6wGAj {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q .VideoDetails_Details__4Ej1c .VideoDetails_Actions__6wGAj span {
  font-size: 14px !important;
}
body[dir=ltr] .VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q .VideoDetails_Details__4Ej1c .VideoDetails_Actions__6wGAj span {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q .VideoDetails_Details__4Ej1c .VideoDetails_Actions__6wGAj span {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
.VideoDetails_VideoDetails__IVkEA .VideoDetails_AccordionRow__JkP\\+Q .VideoDetails_Details__4Ej1c .VideoDetails_Actions__6wGAj span:not(:last-child) {
  -webkit-margin-end: 30px;
          margin-inline-end: 30px;
}

.VideoDetails_commentImg__HJjAs {
  width: 33px;
  height: 33px;
  -webkit-margin-end: 15px;
          margin-inline-end: 15px;
  border-radius: 100%;
  overflow: hidden;
}
.VideoDetails_commentImg__HJjAs img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/VideoDetails/VideoDetails.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;ADgDA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;AC9CF;;ADiHE;EACE,WAAA;AC9GJ;ADiHE;EACE,kCAAA;AC/GJ;ADkHE;EACE,kCAAA;AChHJ;;AA9DA;EACE,yBAAA;EACA,gCAAA;EACA,oCAAA;AAiEF;AAhEE;EDwGE,0BAAA;ECtGA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAkEJ;ADiCI;EACE,2DAAA;AC/BN;ADiCI;EACE,2DAAA;AC/BN;AAvEI;EACE,gDAAA;UAAA,+CAAA;EACA,wBAAA;UAAA,uBAAA;EACA,yBAAA;UAAA,wBAAA;AAyEN;AAtEE;EACE,4BAAA;AAwEJ;AAtEE;EACE,0BAAA;EDmFA,0BAAA;ACVJ;AArEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAuEJ;AArEI;ED6EA,0BAAA;ACLJ;ADMI;EACE,2DAAA;ACJN;ADMI;EACE,2DAAA;ACJN;AAzEE;EACE,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;AA2EJ;ADsCE;ECrHA;IAOI,sBAAA;EA4EJ;AACF;AA1EI;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;UAAA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA4EN;ADwBE;EC3GE;IAUI,qBAAA;YAAA,oBAAA;IACA,mBAAA;IACA,WAAA;EA6EN;AACF;AA3EM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA6ER;AA1EM;EAEE,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AA2ER;AAtEM;EDuBF,0BAAA;ECrBI,kBAAA;AAwER;ADlDI;EACE,2DAAA;ACoDN;ADlDI;EACE,2DAAA;ACoDN;AA5EM;EACE,iBAAA;AA8ER;AA5EM;EDcF,0BAAA;ECZI,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;AA8ER;AA5EM;EACE,eAAA;AA8ER;AA3EI;EACE,mBAAA;AA6EN;AA5EM;EDAF,0BAAA;ECEI,kBAAA;AA8ER;AD/EI;EACE,2DAAA;ACiFN;AD/EI;EACE,2DAAA;ACiFN;AAlFM;EAEE,eAAA;AAmFR;AA7EI;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AA+EN;AA5EI;EACE,aAAA;EACA,aAAA;EAAA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,QAAA;AA8EN;AA5EM;EACE,aAAA;EAAA,mBAAA;AA8ER;AA1EI;EACE,SAAA;EACA,kBAAA;EACA,wBAAA;UAAA,uBAAA;EACA,uBAAA;EDzCF,0BAAA;ACsHJ;AA1EM;EACE,SAAA;EACA,wBAAA;UAAA,uBAAA;AA4ER;AAxEI;EACE,mBAAA;EACA,sBAAA;AA0EN;AAvEI;EACE,eAAA;AAyEN;AArEE;EACE,aAAA;EACA,uBAAA;EACA,2BAAA;AAuEJ;AArEI;EACE,mBAAA;EACA,oBAAA;EACA,2CAAA;AAuEN;AApEI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,wBAAA;UAAA,uBAAA;AAsEN;AApEM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAsER;AAjEM;EDvFF,0BAAA;ECyFI,kBAAA;EACA,0BAAA;AAmER;AD5JI;EACE,2DAAA;AC8JN;AD5JI;EACE,2DAAA;AC8JN;AAtEM;ED/FF,0BAAA;ECiGI,mBAAA;AAwER;AArEM;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AAuER;AArEQ;EDvGJ,0BAAA;AC+KJ;AD9KI;EACE,2DAAA;ACgLN;AD9KI;EACE,2DAAA;ACgLN;AA3EU;EACE,wBAAA;UAAA,uBAAA;AA6EZ;;AAtEA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;UAAA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAyEF;AAxEE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA0EJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.VideoDetails {\n  padding: 20px 20px 0 20px;\n  background-color: var(--bgColor);\n  border: 1px solid var(--borderColor);\n  .Tabs {\n    @include fontSize(14);\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    cursor: pointer;\n    margin-bottom: 20px;\n    &__ArTab {\n      border-inline-end: 1px solid var(--borderColor);\n      margin-inline-end: 20px;\n      padding-inline-end: 20px;\n    }\n  }\n  .active {\n    color: var(--secondaryColor);\n  }\n  .heading {\n    text-transform: capitalize;\n    @include fontSize(10);\n  }\n\n  &_Title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n\n    h3 {\n      @include fontSize(14);\n    }\n  }\n\n  &_Content {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin-bottom: 20px;\n\n    @include Sm {\n      flex-direction: column;\n    }\n\n    .VideoImg {\n      width: 332px;\n      height: 223px;\n      overflow: hidden;\n      margin-inline-end: 20px;\n      position: relative;\n      flex-shrink: 0;\n      cursor: pointer;\n\n      @include Sm {\n        margin-inline-end: 0;\n        margin-bottom: 20px;\n        width: 100%;\n      }\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n\n      .VideoBtn {\n        @extend %centeredHrVr;\n        background-color: var(--bgColor);\n        width: 61px;\n        height: 61px;\n        border-radius: 50%;\n        -webkit-border-radius: 50%;\n        -moz-border-radius: 50%;\n        -ms-border-radius: 50%;\n        -o-border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: var(--secondaryColor);\n      }\n    }\n\n    .VideoPost {\n      h5 {\n        @include fontSize(14);\n        margin-bottom: 5px;\n      }\n      .showLessDetails {\n        max-height: 150px;\n      }\n      .videoPost_Text {\n        @include fontSize(12);\n        line-height: 22px;\n        width: 100%;\n        white-space: pre-line;\n        overflow: hidden;\n        margin-bottom: 20px;\n        font-family: inherit;\n        word-break: break-word;\n      }\n      .showMoreDetailsToggle {\n        cursor: pointer;\n      }\n    }\n    .SpeechToText {\n      margin-bottom: 30px;\n      h5 {\n        @include fontSize(14);\n        margin-bottom: 5px;\n      }\n      span {\n        // @include fontSize(12);\n        font-size: 12px;\n      }\n    }\n  }\n\n  :global {\n    .MuiAccordion-root {\n      margin-top: 0;\n      border: 0;\n      display: flex;\n      flex-direction: column;\n    }\n\n    .MuiAccordionSummary-root {\n      padding: 12px;\n      min-height: unset;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-top: 1px solid var(--borderColor);\n      order: 1;\n\n      &.Mui-expanded {\n        min-height: unset;\n      }\n    }\n\n    .MuiAccordionSummary-content {\n      margin: 0;\n      flex-grow: unset;\n      margin-inline-end: 10px;\n      color: var(--mainColor);\n      @include fontSize(10);\n\n      &.Mui-expanded {\n        margin: 0;\n        margin-inline-end: 10px;\n      }\n    }\n\n    .MuiAccordionDetails-root {\n      padding: 0 0 20px 0;\n      flex-direction: column;\n    }\n\n    .MuiIconButton-edgeEnd {\n      margin-right: 0;\n    }\n  }\n\n  .AccordionRow {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n\n    &:not(:last-child) {\n      margin-bottom: 20px;\n      padding-bottom: 20px;\n      border-bottom: 1px solid var(--borderColor);\n    }\n\n    .Img {\n      width: 33px;\n      height: 33px;\n      border-radius: 50%;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      overflow: hidden;\n      flex-shrink: 0;\n      margin-inline-end: 15px;\n\n      svg {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n\n    .Details {\n      h5 {\n        @include fontSize(14);\n        margin-bottom: 5px;\n        text-transform: capitalize;\n      }\n\n      p {\n        @include fontSize(12);\n        margin-bottom: 10px;\n      }\n\n      .Actions {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n\n        span {\n          @include fontSize(14);\n\n          &:not(:last-child) {\n            margin-inline-end: 30px;\n          }\n        }\n      }\n    }\n  }\n}\n.commentImg {\n  width: 33px;\n  height: 33px;\n  margin-inline-end: 15px;\n  border-radius: 100%;\n  overflow: hidden;\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"VideoDetails_Content": `VideoDetails_VideoDetails_Content__-UNo9`,
	"VideoImg": `VideoDetails_VideoImg__ZwTmT`,
	"VideoBtn": `VideoDetails_VideoBtn__CakRH`,
	"scroll": `VideoDetails_scroll__cJR2D`,
	"VideoDetails": `VideoDetails_VideoDetails__IVkEA`,
	"Tabs": `VideoDetails_Tabs__HHpPB`,
	"Tabs__ArTab": `VideoDetails_Tabs__ArTab__Mc76h`,
	"active": `VideoDetails_active__ribWV`,
	"heading": `VideoDetails_heading__OfVcZ`,
	"VideoDetails_Title": `VideoDetails_VideoDetails_Title__8rDvt`,
	"VideoPost": `VideoDetails_VideoPost__V4jSB`,
	"showLessDetails": `VideoDetails_showLessDetails__cw+ev`,
	"videoPost_Text": `VideoDetails_videoPost_Text__lyXC7`,
	"showMoreDetailsToggle": `VideoDetails_showMoreDetailsToggle__aXEou`,
	"SpeechToText": `VideoDetails_SpeechToText__GQ5g+`,
	"AccordionRow": `VideoDetails_AccordionRow__JkP+Q`,
	"Img": `VideoDetails_Img__A+kyh`,
	"Details": `VideoDetails_Details__4Ej1c`,
	"Actions": `VideoDetails_Actions__6wGAj`,
	"commentImg": `VideoDetails_commentImg__HJjAs`
};
export default ___CSS_LOADER_EXPORT___;
